/**
 * PEP Free-Gift automation
 * ------------------------------------------------------------------
 * Keeps exactly 1 free ($0) gift product in the cart whenever there is
 * at least one paid item, and removes it when there are none (or when the
 * feature is disabled). Config comes from window.PEP_GIFT, injected in
 * <head> by snippets/pep-hidden-guard.liquid.
 *
 * Reconciles on load and on every `cart:update` event. After it changes the
 * cart it dispatches a source-tagged `cart:update` so the header count + cart
 * drawer refresh WITHOUT re-triggering this reconcile (loop guard).
 */
(function () {
  var G = window.PEP_GIFT || {};
  if (!G.handle || !G.variantId) return;

  var QTY = 1; // 1 free gift per ORDER. For 1 per paid item: set QTY = paid.
  var SOURCE = 'pep-free-gift';
  var busy = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function cartJs() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }
  function post(url, body) {
    return fetch(root() + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().catch(function () {
        return {};
      });
    });
  }

  function reconcile() {
    if (busy) return;
    busy = true;
    var added = false;

    return cartJs()
      .then(function (cart) {
        var gift = null;
        var paid = 0;
        (cart.items || []).forEach(function (item) {
          if (item.handle === G.handle) {
            gift = item;
          } else {
            paid += item.quantity;
          }
        });

        var enabled = G.enabled !== false;
        var want = enabled && paid > 0 ? QTY : 0;
        var have = gift ? gift.quantity : 0;

        if (have === want) return null;
        if (want === 0) return post('cart/change.js', { id: gift.key, quantity: 0 });
        if (!gift && G.available === false) return null; // can't add out-of-stock; don't spam
        if (!gift) {
          added = true;
          return post('cart/add.js', { id: G.variantId, quantity: want });
        }
        return post('cart/change.js', { id: gift.key, quantity: want });
      })
      .then(function (changed) {
        if (!changed) return;
        if (added && G.showPopup !== false) showToast(G.message);
        return cartJs().then(function (c) {
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: { data: { itemCount: c.item_count, source: SOURCE } },
            })
          );
        });
      })
      .catch(function () {})
      .finally(function () {
        busy = false;
      });
  }

  /* ---- Toast --------------------------------------------------------- */
  var toastEl = null;
  var toastTimer = null;

  function buildToast() {
    var el = document.createElement('div');
    el.className = 'pep-gift-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');

    var icon = document.createElement('span');
    icon.className = 'pep-gift-toast__icon';
    icon.textContent = '🎁';

    var msg = document.createElement('span');
    msg.className = 'pep-gift-toast__msg';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'pep-gift-toast__close';
    close.setAttribute('aria-label', 'Dismiss');
    close.textContent = '×';
    close.addEventListener('click', hideToast);

    el.appendChild(icon);
    el.appendChild(msg);
    el.appendChild(close);
    document.body.appendChild(el);
    return el;
  }

  function showToast(message) {
    if (!document.body) return;
    if (!toastEl) toastEl = buildToast();
    toastEl.querySelector('.pep-gift-toast__msg').textContent =
      message || 'Free gift added to your order!';

    // Force reflow so the transition runs even if re-shown quickly.
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');

    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 4500);
  }

  function hideToast() {
    if (toastEl) toastEl.classList.remove('is-visible');
    if (toastTimer) {
      clearTimeout(toastTimer);
      toastTimer = null;
    }
  }

  /* ---- Wire up ------------------------------------------------------- */
  document.addEventListener('cart:update', function (e) {
    var src = e.detail && e.detail.data && e.detail.data.source;
    if (src === SOURCE) return; // ignore our own dispatch (loop guard)
    reconcile();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
